import { VodButton, VodButtonLink } from './VodButton.style'
import { ottRoot } from '../../Ott/Api'

const VodIcon = () => {
  return (
    <svg
      width='28'
      height='16'
      viewBox='0 0 28 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M0 15.8436H3.60571V0L0.755017 0.00090712C0.338057 0.00090712 0.000226607 0.320825 0.000226607 0.715112V15.8438L0 15.8436Z'
        fill='white'
      />
      <path
        d='M11.556 9.09516C11.9408 9.46632 12.1786 9.9742 12.1786 10.5351C12.1786 11.6717 11.2046 12.593 10.0029 12.593C8.80124 12.593 7.85713 11.6989 7.82856 10.5859H4.22852C4.25731 13.5792 6.83139 15.9976 10.0029 15.9976C13.1744 15.9976 15.778 13.552 15.778 10.5351C15.778 9.03417 15.1375 7.67492 14.1013 6.6875L11.556 9.09516Z'
        fill='white'
      />
      <path
        d='M11.9638 3.25781L8.53404 6.50189C8.3005 6.72272 8.3005 7.08073 8.53404 7.30157L10.5433 9.20226L15.406 4.60278V3.25804H11.9636L11.9638 3.25781Z'
        fill='#00F2C9'
      />
      <path d='M15.4063 0L11.9639 3.25337H15.4063V0Z' fill='#FFD400' />
      <path d='M15.4065 0H4.41113V3.25337H11.964L15.4065 0Z' fill='#FF1480' />
      <path
        d='M27.2584 6.36719H24.0166V9.609H27.2584V6.36719Z'
        fill='#FFD400'
      />
      <path
        d='M24.0167 9.61719H20.7749V12.859H24.0167V9.61719Z'
        fill='#00F2C9'
      />
      <path d='M20.7706 6.36719H17.5288V9.609H20.7706V6.36719Z' fill='white' />
      <path
        d='M24.0167 3.14062H20.7749V6.38243H24.0167V3.14062Z'
        fill='#FF1480'
      />
    </svg>
  )
}

export const VodButtonComp = () => {
  return (
    <VodButtonLink href={ottRoot}>
      <VodButton>
        <VodIcon />
      </VodButton>
    </VodButtonLink>
  )
}
